import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {
  DailyWorkingTimings,
  WorkingTimings,
  WorkingTimingsConfig,
} from '@drl/shared/models';

@Injectable()
export class WorkingTimingsConfigsAdapter
  implements IAdapter<WorkingTimingsConfig>
{
  adaptToModel(resp: any): WorkingTimingsConfig {
    const workingTimingsResp = resp.configValue.workingTimings;
    const workingTimingsCompleteResp = resp.configValue;
    const dailyWorkingTiming: DailyWorkingTimings[] = [];

    workingTimingsResp.forEach(workingTiming => {
      const timing = new DailyWorkingTimings();
      const amPmIndex = 2;
      if (workingTiming.key) {
        timing.day = workingTiming.key;
      }
      if (workingTiming.value.startTime) {
        const startValues = workingTiming.value.startTime.split(':');
        timing.startTimeHours = startValues[0];
        timing.startTimeMinutes = startValues[1];
        timing.startTimeAmPm = startValues[amPmIndex];
      }
      if (workingTiming.value.endTime) {
        const endValues = workingTiming.value.endTime.split(':');
        timing.endTimeHours = endValues[0];
        timing.endTimeMinutes = endValues[1];
        timing.endTimeAmPm = endValues[amPmIndex];
      }
      dailyWorkingTiming.push(timing);
    });

    const timings: WorkingTimings = {
      workingTimings: dailyWorkingTiming,
      workingMsg: workingTimingsCompleteResp.workingMsg,
      nonWorkingMsg: workingTimingsCompleteResp.nonWorkingMsg
    };

    return {
      id: resp.id,
      configKey: resp.configKey,
      configValue: timings,
    };
  }
  adaptFromModel(data: WorkingTimingsConfig): any {
    const workingTimingData: DailyWorkingTimings[] =
      data.configValue.workingTimings;
    const workingTimingsComplete = data.configValue;

    const dailyTimings: object[] = [];

    workingTimingData.forEach(workingTiming => {
      const startTime = `${workingTiming.startTimeHours}:${workingTiming.startTimeMinutes}:${workingTiming.startTimeAmPm}`;

      const endTime = `${workingTiming.endTimeHours}:${workingTiming.endTimeMinutes}:${workingTiming.endTimeAmPm}`;

      dailyTimings.push({
        key: workingTiming.day,
        value: {
          startTime,
          endTime,
        },
      });
    });

    const confgiVal = {
      workingTimings: dailyTimings,
      workingMsg: workingTimingsComplete.workingMsg,
      nonWorkingMsg: workingTimingsComplete.nonWorkingMsg
    };

    return {
      id: data.id,
      configKey: data.configKey,
      configValue: confgiVal,
    };
  }
}
